import React, { useState, useEffect, useCallback, useRef } from 'react';
import { safeJson, networkMessage } from '../apiHelpers';

const C = {
  primary: '#0F6E56', primaryBg: '#E1F5EE', border: '#E3E1D9',
  text: '#1F1E1B', muted: '#5F5E5A', surface: '#F7F5F0',
  gold: '#91600C', danger: '#C0392B',
};

const API = '/api/freelance';

function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

function myUsername() {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      if (u && u.username) return u.username;
    }
  } catch (e) {}
  return localStorage.getItem('username') || '';
}

function clock(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.getHours().toString().padStart(2, '0') + ':' +
         d.getMinutes().toString().padStart(2, '0');
}

/**
 * Order ke andar chat. Band halat mein sirf ek button, khulne par
 * poori guftagu - nizam ke paigham bhi (delivery, revision, dispute).
 */
export default function OrderChat({ orderId, unread = 0, autoOpen = false }) {
  const [open, setOpen] = useState(!!autoOpen);
  const [d, setD] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const boxRef = useRef(null);
  const me = myUsername();

  const load = useCallback(() => {
    fetch(`${API}/orders/${orderId}/messages/`, { headers: authHeaders() })
      .then((r) => r.json())
      .then((j) => {
        setD(j);
        setTimeout(() => {
          if (boxRef.current) boxRef.current.scrollTop = boxRef.current.scrollHeight;
        }, 60);
      })
      .catch(() => setErr('Could not load the chat.'));
  }, [orderId]);

  useEffect(() => {
    if (!open) return;
    load();
    const t = setInterval(load, 20000);   // har 20 second refresh
    return () => clearInterval(t);
  }, [open, load]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true); setErr('');
    try {
      const res = await fetch(`${API}/orders/${orderId}/messages/send/`, {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ body: text }),
      });
      const j = await safeJson(res);
      if (!res.ok) throw new Error(j.error || 'Could not send.');
      setText('');
      load();
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        style={{
          fontSize: 11.5, padding: '5px 11px', borderRadius: 7,
          border: `1px solid ${unread ? C.primary : C.border}`,
          background: unread ? C.primaryBg : '#fff',
          color: unread ? C.primary : C.muted,
          fontWeight: unread ? 700 : 400, cursor: 'pointer', marginTop: 6,
        }}
      >
        {'\u{1F4AC}'} Order chat{unread ? ` (${unread})` : ''}
      </button>
    );
  }

  return (
    <div style={{ marginTop: 8, border: `1px solid ${C.border}`, borderRadius: 9, overflow: 'hidden' }}>
      <div style={{ background: C.surface, padding: '6px 10px', display: 'flex',
                    justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 12, fontWeight: 700 }}>
          {'\u{1F4AC}'} Chat{d && d.other_user ? ` with @${d.other_user}` : ''}
        </span>
        <button onClick={() => setOpen(false)}
          style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 14, color: C.muted }}>
          {'\u00d7'}
        </button>
      </div>

      <div ref={boxRef} style={{ maxHeight: 260, overflowY: 'auto', padding: '8px 10px', background: '#fff' }}>
        {!d ? (
          <p style={{ fontSize: 11.5, color: C.muted, textAlign: 'center', padding: '1rem 0' }}>Loading…</p>
        ) : d.messages.length === 0 ? (
          <p style={{ fontSize: 11.5, color: C.muted, textAlign: 'center', padding: '1rem 0' }}>
            No messages yet. Say hello, ask a question, or share a file.
          </p>
        ) : d.messages.map((m) => {
          if (m.is_system) {
            return (
              <p key={m.id} style={{ fontSize: 10.5, color: C.muted, textAlign: 'center',
                                     margin: '7px 0', fontStyle: 'italic' }}>
                {m.body} · {clock(m.at)}
              </p>
            );
          }
          const mine = m.sender === me;
          return (
            <div key={m.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start', marginBottom: 6 }}>
              <div style={{
                maxWidth: '78%', background: mine ? C.primaryBg : C.surface,
                borderRadius: 9, padding: '6px 9px',
              }}>
                {!mine && (
                  <p style={{ margin: '0 0 2px', fontSize: 10, fontWeight: 700, color: C.primary }}>
                    @{m.sender}
                  </p>
                )}
                {m.body && (
                  <p style={{ margin: 0, fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {m.body}
                  </p>
                )}
                {m.attachment && (
                  <a href={m.attachment.url} target="_blank" rel="noopener noreferrer"
                     style={{ display: 'block', marginTop: 4, fontSize: 11, color: C.primary }}>
                    {'\u{1F4CE}'} {m.attachment.filename}
                  </a>
                )}
                <p style={{ margin: '2px 0 0', fontSize: 9, color: C.muted, textAlign: 'right' }}>
                  {clock(m.at)}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {d && d.can_send ? (
        <div style={{ borderTop: `1px solid ${C.border}`, padding: '6px 8px', background: '#fff' }}>
          {err && <p style={{ margin: '0 0 4px', fontSize: 10.5, color: C.danger }}>{err}</p>}
          <div style={{ display: 'flex', gap: 6 }}>
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' && !busy) send(); }}
              placeholder="Type a message…"
              style={{ flex: 1, padding: '7px 10px', fontSize: 12.5,
                       border: `1px solid ${C.border}`, borderRadius: 7 }}
            />
            <button onClick={send} disabled={busy}
              style={{ fontSize: 12, fontWeight: 700, padding: '7px 14px', border: 'none',
                       borderRadius: 7, background: C.primary, color: '#fff',
                       cursor: busy ? 'wait' : 'pointer' }}>
              {busy ? '…' : 'Send'}
            </button>
          </div>
          <p style={{ margin: '4px 0 0', fontSize: 9.5, color: C.muted }}>
            Attach files with the {'\u{1F4CE}'} button above — they show up here too.
          </p>
        </div>
      ) : d ? (
        <p style={{ fontSize: 11, color: C.muted, textAlign: 'center', padding: '8px 0', margin: 0,
                    borderTop: `1px solid ${C.border}` }}>
          This order is closed.
        </p>
      ) : null}
    </div>
  );
}
